export default "__VITE_ASSET__be008819__"